// extracted by mini-css-extract-plugin
module.exports = {"selectInput":"SelectInput__selectInput___3efO4"};